import React, { useEffect } from 'react';

import amplitude from 'amplitude-js';
import { getRecipientTypeParam, transactionMethods } from 'apps/auth/components/utils/AmplitudeUtils';
import { ADDITIONAL_INFO_SHOWN, PAYOUT_METHOD_GUIDE_SCREEN_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { PAYMENT_METHOD_AMPLITUDE, PAYOUT_COUNTRY, PAYOUT_METHOD, RECIPIENT_TYPE } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { resolveArguments } from 'apps/auth/helpers/utils';
import { useAuth, useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

import NewClientSideDisclaimer from './NewClientSideDisclaimer';
import ServerSideDisclaimer from './ServerSideDisclaimer';

const NewDisclaimer = (props) => {
    const { countryId } = useAuth();
    const { deliveryMethod, toCountry, isDisclaimerFromServerSide, disclaimerFromServerSide } = useExtra();
    const { notificationNameTo } = usePageMessages();

    const amplitudeDeliveryMethod = transactionMethods[deliveryMethod];
    const amplitudePaymentMethod = transactionMethods[props.paymentMethod];

    useEffect(() => {
        amplitude.getInstance().logEvent(ADDITIONAL_INFO_SHOWN, {
            [PAYOUT_COUNTRY]: toCountry?.nameEn,
            [PAYOUT_METHOD]: amplitudeDeliveryMethod,
            [PAYMENT_METHOD_AMPLITUDE]: amplitudePaymentMethod,
        });
        amplitude.getInstance().logEvent(PAYOUT_METHOD_GUIDE_SCREEN_SHOWN, {
            [PAYOUT_COUNTRY]: toCountry?.nameEn,
            [PAYOUT_METHOD]: amplitudeDeliveryMethod,
            [RECIPIENT_TYPE]: getRecipientTypeParam(props.recipientType),
        });
    }, []);

    return (
        <>
            {isDisclaimerFromServerSide && disclaimerFromServerSide && Object.keys(disclaimerFromServerSide).length > 0 ? (
                <ServerSideDisclaimer
                    title={resolveArguments(disclaimerFromServerSide.title, notificationNameTo)}
                    content={disclaimerFromServerSide}
                    onButtonClick={props.clickAgree}
                    userCountry={countryId}
                    detailsClick={props.detailsClick}
                    onCloseClick={props.onCloseClick}
                />
            ) : (
                <NewClientSideDisclaimer onCloseClick={props.onCloseClick} detailsClick={props.detailsClick} onButtonClick={props.clickAgree} />
            )}
        </>
    );
};

export default NewDisclaimer;
